import { useEffect } from "react";

export default function useResizeEffect(f:()=>void) {
    useEffect(() => {
        f();
        window.addEventListener('resize', f);
        return () => window.removeEventListener('resize', f);
    }, [f]);
}